import { render, staticRenderFns } from "./UEStreamClient.vue?vue&type=template&id=2bac28c5&scoped=true"
import script from "./UEStreamClient.vue?vue&type=script&lang=js"
export * from "./UEStreamClient.vue?vue&type=script&lang=js"
import style0 from "./UEStreamClient.vue?vue&type=style&index=0&id=2bac28c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bac28c5",
  null
  
)

export default component.exports